// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=VT323);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: Arial, Helvetica, sans-serif;
}

#score,
#lives {
    position: absolute;
    width: 175px;
    height: 75px;
    left: 20px;
    font-size: 30px;
    color: white;
    padding: 20px 20px 20px 30px;
}

#score {
    top: 20px;
    background-color: rgba(0, 0, 0, 0.7);
}

#lives {
    top: 55px;
}

#item {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 20px;
    right: 20px;
    font-size: 28px;
    color: white;
}

#begin-container,
#end-container,
#countdown,
#paused,
#instructions-container {
    justify-content: center;
    align-items: center;
    height: 100vh;
    min-width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
}

#begin-container,
#end-container {
    display: flex;
}

#countdown,
#paused,
#instructions-container {
    display: none;
}

#begin-content,
#end-content,
#paused-content,
#instructions-content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(86, 210, 255, 0.85);
    /* padding: 30px; */
    /* text-align: center; */
}

#end-content {
    background-color: rgba(255, 77, 0, 0.7);
}

#end-content h1,
#paused-content h1,
#instructions-content h1 {
    font-size: 80px;
    padding-top: 10px;
    color: #fff;
    text-align: center;
}

#end-content h1 {
    padding-top: 180px;
}

#begin-content h1 {
    font-size: 80px;
    padding-top: 10px;
    color: #fff;
    text-align: center;
    /* -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate; */
}

@-webkit-keyframes glow {
    from {
        text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073,
            0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073,
            0 0 70px #e60073;
    }
    to {
        text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6,
            0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6,
            0 0 80px #ff4da6;
    }
}

#countdown h1 {
    font-size: 80px;
}

#begin-content p {
    font-family: 'Open Sans' !important;
    font-weight: 600;
    color: white;
    justify-content: center;
    padding-left: 180px;
    font-size: 20px;
    width: 400px;
    /* border: 2px solid black; */
}

#end-content p,
#paused-content p,
#instructions-content p {
    text-align: center;
    font-family: 'Open Sans' !important;
    /* font-style: italic; */
    color: white;
    font-size: 20px;
}

#end-content p {
    text-align: center;
}

#begin-button,
#end-button,
#instructions-button,
#back-button {
    display: flex;
    height: 50px;
    width: 200px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 20px;
    color: white;
    font-size: 22px;
    border-radius: 15px;
}

#begin-button,
#end-button {
    /* background-color: #31c110; */
    padding-top: 30px;
    font-size: 40px;
    height: 50px;
    width: 400px;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
}

#instructions-button,
#back-button {
    /* background-color: white; */
    color: #fff; /* Text color */
    border: 3px solid #fff; /* Outline using the border property */
}

#instructions-button:hover,
#back-button:hover {
    background-color: white;
    color: rgba(86, 210, 255, 0.85);
}

#writeup-container {
    position: absolute;
    bottom: 40px;
    right: 50px;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 10px;
}

#writeup-container a {
    padding: 0px;
    margin: 0px;
    font-size: 28px;
    text-decoration: none;
    color: white;
}

#writeup-container a:hover {
    text-decoration: underline;
    color: lightgray;
}

#heart {
    position: absolute;
    top: 82px;
    left: 140px;
    display: flex;
}

#heart img {
    height: 25px;
    width: 25px;
    padding-right: 4px;
}

#runner {
    position: absolute;
    top: 82px;
    right: 128px;
    display: flex;
    /* border: 2px solid black; */
}
#runner img {
    height: 400px;
    width: 100%;
    padding-right: 4px;
}
#biker {
    position: absolute;
    top: 80px;
    left: 60px;
    display: flex;
}
#biker img {
    height: 650px;
    width: 100%;
    padding-right: 1px;
    /* border: 2px solid black; */
}
#swimmer {
    position: absolute;
    bottom: 10px;
    right: 20px;
    display: flex;
}
#swimmer img {
    height: 550px;
    width: 100%;
    padding-right: 4px;
    /* border: 2px solid black; */
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAGA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,oCAAoC;AACxC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;;;;;IAKI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;;IAII,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB;;wDAEoD;AACxD;;AAEA;IACI;QACI;;4BAEoB;IACxB;IACA;QACI;;4BAEoB;IACxB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;;;IAGI,kBAAkB;IAClB,mCAAmC;IACnC,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;IAII,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yDAAyD;IACzD,sDAAsD;IACtD,iDAAiD;AACrD;;AAEA;;IAEI,6BAA6B;IAC7B,WAAW,EAAE,eAAe;IAC5B,sBAAsB,EAAE,sCAAsC;AAClE;;AAEA;;IAEI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;AACjB;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=VT323');\n@import url('https://fonts.googleapis.com/css?family=Open+Sans');\n\n* {\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n#score,\n#lives {\n    position: absolute;\n    width: 175px;\n    height: 75px;\n    left: 20px;\n    font-size: 30px;\n    color: white;\n    padding: 20px 20px 20px 30px;\n}\n\n#score {\n    top: 20px;\n    background-color: rgba(0, 0, 0, 0.7);\n}\n\n#lives {\n    top: 55px;\n}\n\n#item {\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    top: 20px;\n    right: 20px;\n    font-size: 28px;\n    color: white;\n}\n\n#begin-container,\n#end-container,\n#countdown,\n#paused,\n#instructions-container {\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    min-width: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n}\n\n#begin-container,\n#end-container {\n    display: flex;\n}\n\n#countdown,\n#paused,\n#instructions-container {\n    display: none;\n}\n\n#begin-content,\n#end-content,\n#paused-content,\n#instructions-content {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: rgba(86, 210, 255, 0.85);\n    /* padding: 30px; */\n    /* text-align: center; */\n}\n\n#end-content {\n    background-color: rgba(255, 77, 0, 0.7);\n}\n\n#end-content h1,\n#paused-content h1,\n#instructions-content h1 {\n    font-size: 80px;\n    padding-top: 10px;\n    color: #fff;\n    text-align: center;\n}\n\n#end-content h1 {\n    padding-top: 180px;\n}\n\n#begin-content h1 {\n    font-size: 80px;\n    padding-top: 10px;\n    color: #fff;\n    text-align: center;\n    /* -webkit-animation: glow 1s ease-in-out infinite alternate;\n    -moz-animation: glow 1s ease-in-out infinite alternate;\n    animation: glow 1s ease-in-out infinite alternate; */\n}\n\n@-webkit-keyframes glow {\n    from {\n        text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073,\n            0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073,\n            0 0 70px #e60073;\n    }\n    to {\n        text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6,\n            0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6,\n            0 0 80px #ff4da6;\n    }\n}\n\n#countdown h1 {\n    font-size: 80px;\n}\n\n#begin-content p {\n    font-family: 'Open Sans' !important;\n    font-weight: 600;\n    color: white;\n    justify-content: center;\n    padding-left: 180px;\n    font-size: 20px;\n    width: 400px;\n    /* border: 2px solid black; */\n}\n\n#end-content p,\n#paused-content p,\n#instructions-content p {\n    text-align: center;\n    font-family: 'Open Sans' !important;\n    /* font-style: italic; */\n    color: white;\n    font-size: 20px;\n}\n\n#end-content p {\n    text-align: center;\n}\n\n#begin-button,\n#end-button,\n#instructions-button,\n#back-button {\n    display: flex;\n    height: 50px;\n    width: 200px;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin-top: 20px;\n    color: white;\n    font-size: 22px;\n    border-radius: 15px;\n}\n\n#begin-button,\n#end-button {\n    /* background-color: #31c110; */\n    padding-top: 30px;\n    font-size: 40px;\n    height: 50px;\n    width: 400px;\n    -webkit-animation: glow 1s ease-in-out infinite alternate;\n    -moz-animation: glow 1s ease-in-out infinite alternate;\n    animation: glow 1s ease-in-out infinite alternate;\n}\n\n#instructions-button,\n#back-button {\n    /* background-color: white; */\n    color: #fff; /* Text color */\n    border: 3px solid #fff; /* Outline using the border property */\n}\n\n#instructions-button:hover,\n#back-button:hover {\n    background-color: white;\n    color: rgba(86, 210, 255, 0.85);\n}\n\n#writeup-container {\n    position: absolute;\n    bottom: 40px;\n    right: 50px;\n    background-color: rgba(0, 0, 0, 0.7);\n    padding: 10px;\n}\n\n#writeup-container a {\n    padding: 0px;\n    margin: 0px;\n    font-size: 28px;\n    text-decoration: none;\n    color: white;\n}\n\n#writeup-container a:hover {\n    text-decoration: underline;\n    color: lightgray;\n}\n\n#heart {\n    position: absolute;\n    top: 82px;\n    left: 140px;\n    display: flex;\n}\n\n#heart img {\n    height: 25px;\n    width: 25px;\n    padding-right: 4px;\n}\n\n#runner {\n    position: absolute;\n    top: 82px;\n    right: 128px;\n    display: flex;\n    /* border: 2px solid black; */\n}\n#runner img {\n    height: 400px;\n    width: 100%;\n    padding-right: 4px;\n}\n#biker {\n    position: absolute;\n    top: 80px;\n    left: 60px;\n    display: flex;\n}\n#biker img {\n    height: 650px;\n    width: 100%;\n    padding-right: 1px;\n    /* border: 2px solid black; */\n}\n#swimmer {\n    position: absolute;\n    bottom: 10px;\n    right: 20px;\n    display: flex;\n}\n#swimmer img {\n    height: 550px;\n    width: 100%;\n    padding-right: 4px;\n    /* border: 2px solid black; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
